export const shadows = {
  sm: "0 1px 2px rgba(0,0,0,.06)",
  md: "0 8px 24px rgba(2,6,23,.12)",
  lg: "0 16px 40px rgba(2,6,23,.18)",
  xl: "0 24px 64px rgba(2,6,23,.22)",
} as const;
